module.exports = __webpack_public_path__ + "static/media/14UNEP21.1518d40d.jpg";